var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadphoneSvgrepoCom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2261_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3334 19.9043C33.3334 12.6035 27.3739 6.66683 20 6.66683C12.6262 6.66683 6.66671 12.6035 6.66671 19.9043C6.66671 21.8875 6.91102 23.1642 7.21409 24.0977C7.41589 24.719 7.90201 24.1073 8.14117 23.883C9.77787 22.3473 12.3369 22.3838 13.929 23.9658C16.297 26.3185 18.481 29.5818 15.4635 32.5818C13.8435 34.1925 11.4038 34.8623 9.54727 33.1277C7.15064 30.8882 5.06814 28.2822 4.04369 25.127C3.61504 23.8068 3.33337 22.175 3.33337 19.9043C3.33337 10.7425 10.8054 3.3335 20 3.3335C29.1947 3.3335 36.6667 10.7425 36.6667 19.9043C36.6667 22.175 36.385 23.8068 35.9564 25.127C34.9319 28.2822 32.8494 30.8882 30.4529 33.1277C28.5962 34.8623 26.1565 34.1925 24.5365 32.5818C21.519 29.5818 23.703 26.3185 26.071 23.9658C27.6632 22.3838 30.2222 22.3473 31.8589 23.883C32.3209 24.3165 32.5477 24.8317 32.786 24.0977C33.089 23.1642 33.3334 21.8875 33.3334 19.9043Z",
    fill: "#2D3B36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2261_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphoneSvgrepoCom1);
export default __webpack_public_path__ + "static/media/headphone-svgrepo-com 1.0347d4c8fe363f375b0305b613800919.svg";
export { ForwardRef as ReactComponent };